<template>
  <div>
    <canvas ref="barChart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js/auto';
export default {
  props: {
    labels_mode: {
      required: true,
      type: Object
    },
    labels: {
      required: true,
      type: Array
    },
    dataset: {
      required: true,
      type: Object
    },
    x_axis_title: {
      required: true,
      type: String
    },
    y_axis_title: {
      required: true,
      type: String
    },
    legend_position: {
      required: false,
      type: String,
      default: 'top'
    },
    legend_font_size: {
      default: 13,
      required: false,
    },
    stacked: {
      required: false,
      type: Boolean,
      default: false
    },
    height: {
      required: false,
      type: Number,
      default: 400
    },
    labels_mode_background_color: {
      type: Object,
      required: false,
    }
  },
  watch: {
    dataset: {
      deep: true,
      handler(newV, oldV) {
        if (newV == oldV) return
        this.updateChart()
      }
    },
    labels(newV, oldV) {
      if (newV == oldV) return
      this.updateChart()
    },
    labels_mode_background_color() {
      this.updateChart()
    }
  },
  mounted() {
    this.renderChart()
    this.setHeight()
  },
  methods: {
    updateChart() {
      this._barChart.destroy();
      this.renderChart()
      this.setHeight()
    },
    renderChart() {
      this._barChart = new Chart(
        this.$refs.barChart,
        {
          type: 'bar',
          options: {
            // aspectRatio: 2.5, // Adjust the aspect ratio as per your requirement
            maintainAspectRatio: false,
            interaction: {
              mode: 'index'
            },
            scales: {
              x: {
                title: {
                  display: true,
                  text: this.x_axis_title,
                  font: {
                    weight: 'bold'
                  }
                },
                stacked: this.stacked
              },
              y: {
                title: {
                  display: true,
                  text: this.y_axis_title,
                  font: {
                    weight: 'bold'
                  }
                },
                stacked: this.stacked
              }
            },
            animation: true,
            responsive: true,
            plugins: {
              legend: {
                display: true,
                position: this.legend_position,
                labels: {
                  usePointStyle: true,
                  pointStyle: 'rectRounded',
                  font: {
                    weight: 'bold',
                    size: this.legend_font_size,
                  }
                }
              },
              tooltip: {
                enabled: true
              }
            }
          },
          data: this.prepareDataset()
        }
      );
    },
    prepareDataset() {

      let result = []
      Object.keys(this.dataset).forEach(key => {
        let temp_payload = {
          label: this.labels_mode[key] || 'Unknown',
          backgroundColor: this.labels_mode_background_color ? this.labels_mode_background_color[key] : 'rgba(' + this.getRandomValue() + ', ' + this.getRandomValue() + ', ' + this.getRandomValue() + ', 0.8)',
          data: this.dataset[key],
          fill: true,
          borderRadius: 10,
        }
        result.push(temp_payload)
      })

      return {
        labels: this.labels,
        datasets: result
      }
    },
    // Function to generate a random color value (0-255)
    getRandomValue() {
      return Math.floor(Math.random() * 256);
    },
    setHeight(){
      const barChart = this.$refs.barChart
      const chartHeight = this.height ? this.height : 400;
      barChart.style.height = `${chartHeight}px`;
    }
  }
}
</script>